import React from 'react';
import { getTechnicianColor } from '../../util/colorCodingUtils';

/**
 * Small color-swatch + name chip for a technician.
 * Three usage shapes — pick whichever the caller already has:
 *   <TechBadge name="Alex" color="#7AC6FF" />
 *   <TechBadge tech={{ User_id, user_name, user_color }} />
 *   <TechBadge technicianId={12} technicians={list} />
 *
 * Renders a muted gray swatch when the tech has no color set.
 */
const TechBadge = ({
  name,
  color,
  tech,
  technicianId,
  technicians,
  size = 'sm',
  className = '',
}) => {
  let resolvedName = name;
  let resolvedColor = color;

  if (!resolvedName && tech) {
    resolvedName = tech.user_name || tech.name;
  }
  if (!resolvedColor && tech) {
    resolvedColor = tech.user_color;
  }
  if ((!resolvedName || !resolvedColor) && technicianId && Array.isArray(technicians)) {
    const found = technicians.find(
      (t) => String(t.User_id ?? t.user_id) === String(technicianId)
    );
    if (found) {
      resolvedName = resolvedName || found.user_name;
      resolvedColor = resolvedColor || found.user_color;
    }
    if (!resolvedColor) {
      const c = getTechnicianColor(technicianId, technicians);
      if (c) resolvedColor = c.accent;
    }
  }

  if (!resolvedName) return null;

  const swatchSize = size === 'lg' ? 12 : 8;
  const swatchColor = resolvedColor || '#9CA3AF';

  return (
    <span className={`d-inline-flex align-items-center ${className}`.trim()}>
      <span
        aria-hidden="true"
        style={{
          display: 'inline-block',
          width: swatchSize,
          height: swatchSize,
          borderRadius: '50%',
          backgroundColor: swatchColor,
          marginRight: 6,
          flexShrink: 0,
        }}
      />
      <span>{resolvedName}</span>
    </span>
  );
};

export default TechBadge;
